import { select, call } from 'redux-saga/effects';
// eslint-disable-next-line import/no-extraneous-dependencies
import Auth from '@aws-amplify/auth';

const mapState = ({
 city, state, moduleType, serverConfig,
}) => ({
  city,
  state,
  moduleType,
  dataProvider: serverConfig.namespace,
});

export function* track(action) {
  try {
    const trackState = yield select(mapState);
    analytics.track(action.payload.name, {
      ...trackState,
      ...action.payload,
    });
  } catch (e) {
    console.log(action.payload.name);
  }
}

export function* identify() {
  const currentUser = yield call([Auth, Auth.currentUserInfo]);
  if (currentUser == null) return;
  try {
    analytics.identify(currentUser.attributes.sub, {
      username: currentUser.username,
      email: currentUser.attributes.email,
      phone: currentUser.attributes.phone_number,
    });
  } catch (e) {
    console.log(`User: ${currentUser.attributes.sub}`);
  }
}
